const tabletStartViewport = 768;
const desktopStartViewport = 1152;

const breakpoints = [`${tabletStartViewport}px`, `${desktopStartViewport}px`];
breakpoints.tablet = tabletStartViewport;
breakpoints.desktop = desktopStartViewport;

const space = {
    none: 0,
    xxs: 2,
    xs: 4,
    small: 8,
    median: 12,
    mobile: 16,
    base: 16,
    tablet: 24,
    medium: 24,
    desktop: 32,
    regular: 32,
    large: 40,
    xl: 42,
    xxl: 48,
};

const sizes = space;

const colors = {};
colors['zanichelli-red-main'] = '#e2001a';
colors['zanichelli-red-dark'] = '#80000f';
colors['zanichelli-red-light'] = '#ff808e';

/* PRIMARY myZanichelli Blue  */
colors['myzanichelli-blue-main'] = '#0056c1';
colors['myzanichelli-blue-dark'] = '#003476';
colors['myzanichelli-blue-light'] = '#1973e1';
colors['myzanichelli-blue-lighter'] = '#e1f0ff';

/* ACCENT Azure */
colors['accent-azure-main'] = '#add2ff';
colors['accent-azure-dark'] = '#78b5ff';
colors['accent-azure-light'] = '#d0e9ff';
colors['accent-azure-lighter'] = '#ebf4ff';

/* SURFACE Main colors */
colors['surface-white'] = '#ffffff';
colors['surface-grey-050'] = '#f6f6f6';
colors['surface-grey-200'] = '#e6e6e6';
colors['surface-grey-700'] = '#676b6f';
colors['surface-grey-800'] = '#424548';
colors['surface-grey-900'] = '#333333';

/* SURFACE Additional Neutral colors */
/* WARNING: only use these Neutral shades if main Grey surface colors are not sufficient. */
colors['surface-neutral-100'] = '#e8ebee';
colors['surface-neutral-150'] = '#d9dee3';
colors['surface-neutral-200'] = '#cad1d8';
colors['surface-neutral-300'] = '#aeb8c2';
colors['surface-neutral-400'] = '#919eac';
colors['surface-neutral-500'] = '#738596';
colors['surface-neutral-600'] = '#5c6b7a';
colors['surface-neutral-700'] = '#46525d';
colors['surface-neutral-800'] = '#303840';

/* STATUS Success Green */
colors['success-green-main'] = '#417505';
colors['success-green-dark'] = '#233a00';
colors['success-green-light'] = '#95d150';
colors['success-green-lighter'] = '#effce0';

/* STATUS Error Red */
colors['error-red-main'] = '#dc3122';
colors['error-red-dark'] = '#7e0a00';
colors['error-red-light'] = '#ff9c9c';
colors['error-red-lighter'] = '#fdefee';

/* STATUS Warning Yellow */
colors['warning-yellow-main'] = '#f6bb3b';
colors['warning-yellow-dark'] = '#85641a';
colors['warning-yellow-light'] = '#fee17f';
colors['warning-yellow-lighter'] = '#fbf4e6';

/* TEXT Main colors */
colors['text-white'] = '#ffffff';
colors['text-grey-050'] = '#f6f6f6';
colors['text-grey-200'] = '#e6e6e6';
colors['text-grey-700'] = '#676b6f';
colors['text-grey-800'] = '#424548';

/* TEXT Interactive elements and Titles */
colors['text-myzanichelli-blue-main'] = '#0056c1';
colors['text-myzanichelli-blue-dark'] = '#003476';
colors['text-myzanichelli-blue-light'] = '#1973e1';
colors['text-zanichelli-red-main'] = '#e2001a';
colors['text-zanichelli-red-dark'] = '#80000f';
colors['text-zanichelli-red-light'] = '#ff808e';

/* TEXT Status messages */
colors['text-success-green-main'] = '#417505';
colors['text-error-red-main'] = '#dc3122';
colors['text-warning-yellow-dark'] = '#85641a';

/* Interactive elements & titles see: https://zanichelli.zeroheight.com/styleguide/s/21281/p/68aa0a-colori/b/21ff26*/
colors['disabled'] = '#676B6F';
colors['enabled-blue'] = '#0056C1';
colors['enabled-grey'] = '#424548';
colors['enabled-red'] = '#E2001A';
colors['enabled-white'] = '#FFFFFF';
colors['hover-blue'] = '#003476';
colors['hover-red'] = '#80000F';
colors['pressed-blue'] = '#1973E1';
colors['pressed-red'] = '#FF808E';

/* Alias for typography components */
colors['interactive-hover'] = colors['hover-blue'];
colors['interactive-pressed'] = colors['pressed-blue'];

const shadows = {};
shadows['shadow-01dp'] = '0px 1px 2px 0px rgba(66, 69, 72, 0.35)';
shadows['shadow-02dp'] = '0px 2px 4px 0px rgba(66, 69, 72, 0.35)';
shadows['shadow-03dp'] = '0px 3px 6px 0px rgba(66, 69, 72, 0.35)';
shadows['shadow-04dp'] = '0px 4px 8px 0px rgba(66, 69, 72, 0.35)';
shadows['shadow-06dp'] = '0px 6px 12px 0px rgba(66, 69, 72, 0.35)';
shadows['shadow-12dp'] = '0px 12px 24px 0px rgba(66, 69, 72, 0.35)';

shadows['outline'] = '0px 0px 2px 2px #78b5ff';

const radii = { normal: 4 };

const fontSizes = {};
fontSizes['heading-1'] = '2rem';
fontSizes['heading-1-small'] = '1.75rem';
fontSizes['heading-1-medium'] = '1.75rem';
fontSizes['heading-2'] = '1.75rem';
fontSizes['heading-2-small'] = '1.5rem';
fontSizes['heading-2-medium'] = '1.5rem';
fontSizes['heading-3'] = '1.5rem';
fontSizes['heading-4'] = '1.25rem';
fontSizes['body-1'] = '1.25rem';
fontSizes['body-2'] = '1.125rem';
fontSizes['body-3'] = '1rem';
fontSizes['body-4'] = '0.875rem';
fontSizes['body-5'] = '0.75rem';
fontSizes['interactive-1'] = '1rem';
fontSizes['interactive-2'] = '0.8275rem';
fontSizes['interactive-3'] = '0.75rem';
fontSizes['helper-1'] = '0.75rem';

const fontWeights = {};
fontWeights['semi-bold'] = 600;
fontWeights['regular'] = 400;
fontWeights['light'] = 300;

const lineHeights = {};
lineHeights['heading-1'] = '2.5rem';
lineHeights['heading-1-small'] = '2.25rem';
lineHeights['heading-1-medium'] = '2.25rem';
lineHeights['heading-2'] = '2.25rem';
lineHeights['heading-2-small'] = '2rem';
lineHeights['heading-2-medium'] = '2rem';
lineHeights['heading-3'] = '2rem';
lineHeights['heading-4'] = '1.75rem';
lineHeights['body-1'] = '1.75rem';
lineHeights['body-2'] = '1.75rem';
lineHeights['body-3'] = '1.5rem';
lineHeights['body-4'] = '1.25rem';
lineHeights['body-5'] = '1rem';
lineHeights['interactive-1'] = '1.25rem';
lineHeights['interactive-2'] = '1.25rem';
lineHeights['interactive-3'] = '1rem';
lineHeights['helper-1'] = '1rem';

const theme = {
    name: 'default',
    breakpoints,
    fonts: {
        regular: '"IBM Plex Sans", sans-serif',
        serif: 'IBM Plex Serif',
    },
    fontSizes,
    fontWeights,
    lineHeights,
    space,
    sizes,
    colors,
    radii,
    shadows,
    mediaQueries: {
        tablet: `@media screen and (min-width: ${breakpoints.tablet}px)`,
        desktop: `@media screen and (min-width: ${breakpoints.desktop}px)`,
    },
};

export default theme;
